<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <CadastroPromotor />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>
<script>
import CadastroPromotor from "./../Components/Cadastros/CadastroPromotor.vue";

export default {
  name: "RegisterPromoter",
  components: {
    CadastroPromotor,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>
